import { FC } from "react";
import { Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledErrorWrapper = styled("div")(({ theme }) => ({
  lineHeight: 1.4,
  margin: "45px 0px 0px",
  marginTop: "45px",
  width: "435px",

  "& a": {
    color: theme.colors.sapphire,
    textDecoration: "none",
  },
}));

interface ErrorProps {
  errorMsg: string;
}

const Error: FC<ErrorProps> = ({ errorMsg }) => {
  const theme = useTheme();
  return (
    <StyledErrorWrapper>
      <Typography
        color={theme.colors.error}
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: errorMsg,
        }}
      ></Typography>
    </StyledErrorWrapper>
  );
};

export default Error;
